<template>
  <div data-job-list-items :class="!options.view.listView && $style.tiles">
    <template v-for="item in items">
      <a
        v-if="item.visibility.query && item.visibility.tags"
        :class="itemClassname"
        :key="item.id"
        :href="item.url">
        <div :class="$style.itemWrapper">
          <p
            :class="$style.jobTitle"
            :style="vacancyTitleStyle">
            {{ item.title }}
          </p>
          <div :class="$style.listItemInfo">
            <p
              v-for="(type, index) in item.displayTypes"
              :key="index"
              :class="$style.listItemInfoText">
              {{ type }}
            </p>
          </div>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import cx from 'classnames'

export default {
  name: 'JobListItems',

  props: {
    items: vueTypes.array,
    options: vueTypes.object
  },

  computed: {
    moduleStyle () {
      return this.options.css.modules.vacancies
    },

    headingsStyle () {
      return this.options.css.headings
    },

    itemClassname() {
      const dark = {
        listItem: this.$style.listItem,
        tile: this.$style.tile
      }
      const light = {
        listItem: this.$style.lightListItem,
        tile: this.$style.lightTile
      }

      const theme = this.moduleStyle.backgroundColor === '#ffffff' ? dark : light

      return cx({
        [theme.listItem]: this.options.view.listView,
        [theme.tile]: !this.options.view.listView
      })
    },

    vacancyTitleStyle() {
      return {
        color: this.moduleStyle.textColor,
        fontFamily: this.headingsStyle.fontFamily,
        fontWeight: this.headingsStyle.fontWeight
      }
    }
  }
}
</script>

<style module>
  .tiles {
    display: flex;
    gap: 20px;
    flex-direction: column;
  }

  .listItemInfo {
  }

  .listItem {
    display: block;
    padding: 14px 20px;
    background-color: rgba(0, 0, 0, 0.02);
    border-top: 1px solid $skyLighter;

    &:first-child {
      border-top: none;
      border-top-left-radius: var(--border-radius-career-list);
      border-top-right-radius: var(--border-radius-career-list);
    }

    &:last-child {
      border-bottom-left-radius: var(--border-radius-career-list);
      border-bottom-right-radius: var(--border-radius-career-list);
    }
  }

  .listItem, .tile {
    cursor: pointer;

    background-color: rgba(0, 0, 0, 0.02);

    &:hover {
      background-color: rgba(0, 0, 0, 0.7);

      .jobTitle, .listItemInfoText {
        color: $white !important;
      }
    }
  }

  .lightListItem {
    composes: listItem;
    background-color: $white;
  }

  .listItemInfoText {
    position: relative;
    color: #777;
    line-height: 26px;
    font-size: 16px;
    font-family: 'Inter', sans-serif;
    display: inline-block;
    margin: 0 0 0 10px;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: -6px;
      display: block;
      width: 2px;
      height: 2px;
      background: currentColor;
    }

    &:first-child {
      margin: 0;

      &:before {
        display: none;
      }
    }
  }

  .jobTitle {
    font-size: 18px;
    line-height: 26px;
    margin: 0 0 -4px 0;
    display: inline-block;
  }

  .tile {
    width: 100%;
    height: 160px;
    border-radius: var(--border-radius-career-grid);
    background-color: rgba(0, 0, 0, 0.02);
    text-align: center;
    display: flex;
    align-items: center;
    position: relative;
  }

  .itemWrapper {
    margin: 0 auto;
  }

  .lightTile {
    composes: tile;
    background-color: $white;
  }

  @media screen and (min-width: 767px) {
    .tiles {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
    }

    .tile {
      flex: 0 1 calc((100% - 1 * 20px) / 2);
      max-width: 360px;
    }

    .listItem {
      .itemWrapper {
        margin: 0;
        display: grid;
        grid-template-columns: 55% 45%;
      }

      .listItemInfo {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
      }

      .jobTitle {
        margin: 0 50px 0 0;
      }

      .listItemInfoText {
        &:before {
          display: none;
        }
      }
    }
  }

  @media screen and (min-width: 1140px) {
    .tile {
      flex: 0 1 calc((100% - 2 * 20px) / 3);
    }
  }
</style>
